const EVIDENCE_FIELDS = [
  'id',
  'rowNumber',
  'rowKey',
  'sourceRowKey',
  'storageKey',
  'fileRowId',
  'bac',
  'dealerName',
  'productName',
  'productSelection',
  'productCode',
  'oemProductCode',
  'normalizedProductCode',
  'productStatus',
  'status',
  'isBilling',
  'dealerCost',
  'budget',
  'provider',
  'providerCurrency',
  'invoicePrice',
  'mrr',
  'dealerPrice',
  'quantity',
  'serviceMonth',
  'effectiveDate',
  'activationDate',
  'billingStartDate',
  'billingStartDateDisplay',
  'billingEndDate',
  'billingEndDateDisplay',
  'billingDate',
  'enrollmentDate',
  'productSelectionDate',
  'goLiveDate',
  'cancellationDate',
  'cancelDate',
  'optOutDate',
  'terminationDate',
  'orderStartDate',
  'orderEndDate',
  'isBillable',
  'is_billing',
  'is_billable',
  'lastModified',
  'referenceId',
  'referenceID',
  'orderItemId',
  'matchedAppSheetOrderItemId',
  '__orderItemId',
  'subscriptionId',
  'subscriptionID',
  'SubscriptionId',
  'Subscription ID as Id',
  'Subscription ID',
  'contractId',
  'contractID',
  'ContractId',
  'Contract ID as Id',
  'Contract ID',
  'pricingTableId',
  'pricingTableID',
  'PricingTableId',
  'Pricing Table ID as Id',
  'Pricing Table ID',
  'accountId',
  'salesforceAccountId',
  'salesforceAccountName',
  'displayProductCode',
  'originalCpqProductCode',
  'rawProductCode',
  'inheritedProductCode',
  'hasInheritedDisplayCode',
];

const firstNonBlank = (...values) => values.find((value) => (
  value !== undefined
  && value !== null
  && String(value).trim() !== ''
)) || '';

const normalizeCode = (value) => String(value || '').trim().toUpperCase();

export const compactEvidenceSnapshot = (row = {}) => {
  if (!row || typeof row !== 'object') return {};
  const snapshot = EVIDENCE_FIELDS.reduce((acc, field) => {
    if (row[field] !== undefined && row[field] !== null && row[field] !== '') acc[field] = row[field];
    return acc;
  }, {});
  if (row.accountMatch && typeof row.accountMatch === 'object') {
    snapshot.accountMatch = {
      matchStatus: row.accountMatch.matchStatus,
      matchMethod: row.accountMatch.matchMethod,
      confidence: row.accountMatch.confidence,
      salesforceAccountId: row.accountMatch.salesforceAccountId,
      salesforceAccountName: row.accountMatch.salesforceAccountName,
      orderItemId: row.accountMatch.orderItemId,
      referenceId: row.accountMatch.referenceId,
    };
  }
  return snapshot;
};

export const inheritedCpqOverrideFromContext = (context = {}) => {
  const row = context.row || {};
  const originalProductCode = firstNonBlank(
    context.rawProductCode,
    context.originalCpqProductCode,
    row.rawProductCode,
    row.originalCpqProductCode,
  );
  const inheritedProductCode = firstNonBlank(
    context.inheritedProductCode,
    context.displayProductCode,
    row.inheritedProductCode,
    row.displayProductCode,
    context.productCode,
  );
  const hasOverride = Boolean(
    context.source === 'cpq'
    && originalProductCode
    && inheritedProductCode
    && normalizeCode(originalProductCode) !== normalizeCode(inheritedProductCode)
  );
  return { hasOverride, originalProductCode, inheritedProductCode };
};

const INHERITED_EVIDENCE_BINDING_FIELDS = [
  'accountId',
  'accountMatch',
  'bindingConfidence',
  'bindingMethod',
  'manualOrderItemId',
  'manualReferenceId',
  'matchedAppSheetOrderItemId',
  'orderItemId',
  '__orderItemId',
  'peopleSoftId',
  'peoplesoftId',
  'referenceId',
  'referenceID',
  'ReferenceId',
  'salesforceAccountId',
  'salesforceAccountName',
];

export const scrubInheritedEvidenceBinding = (sourceEvidence = {}) => {
  INHERITED_EVIDENCE_BINDING_FIELDS.forEach((field) => {
    delete sourceEvidence[field];
  });
};
